import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Repairs } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Repairs.Pages.REPAIRS}`,
    name: Repairs.Pages.REPAIRS,
    component: () => import(/* webpackChunkName: "repairs" */ './views/RepairsList.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.REPAIRS],
    },
  },
  {
    path: `/${Repairs.Pages.REPAIRS}/${Repairs.Pages.REPAIR_DETAIL}/:id`,
    name: Repairs.Pages.REPAIR_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "repair-detail" */ './views/RepairDetail.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.REPAIR_DETAIL],
    },
  },
  {
    path: `/${Repairs.Pages.REPAIRS}/${Repairs.Pages.NEW_REPAIR}/`,
    name: Repairs.Pages.NEW_REPAIR,
    component: () => import(/* webpackChunkName: "new-repair" */ './views/NewRepair.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.NEW_REPAIR],
    },
  },
  {
    path: `/${Repairs.Pages.REPAIRS}/${Repairs.Pages.WARRANTY_CHECK}/`,
    name: Repairs.Pages.WARRANTY_CHECK,
    component: () => import(/* webpackChunkName: "warranty-check" */ './views/WarrantyCheck.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.WARRANTY_CHECK],
    },
  },
  {
    path: `/${Repairs.Pages.REPAIRS}/${Repairs.Pages.RETURN_ZIPS}/`,
    name: Repairs.Pages.RETURN_ZIPS,
    component: () => import(/* webpackChunkName: "warranty-check" */ './views/ReturnZips.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.RETURN_ZIPS],
    },
  },
  {
    path: `/${Repairs.Pages.REPAIRS}/${Repairs.Pages.REPAIR_DETAIL}/${Repairs.Pages.EDIT_MAIN_INFO}/:id`,
    name: Repairs.Pages.EDIT_MAIN_INFO,
    component: () => import(/* webpackChunkName: "warranty-check" */ './views/EditMainInfo.vue'),
    meta: {
      access_roles: RouteRoles[Repairs.Pages.EDIT_MAIN_INFO],
    },
  },
];

export default routes;
